import { API } from '../Client';

export interface CopyTradingAsset {
  ticker: string;
  percentage: number; // 0-100 (backend expects sum to equal 100)
}

export interface CreateCopyTradingBody {
  name: string;
  description: string;
  type: string;
  yearlyAvgReturn: number;
  lastYearReturn: number;
  minimumInvestment: number;
  tradeDelay: number;
  assets: CopyTradingAsset[];
}

export interface CopyTradingResponse {
  id: number;
  name: string;
  description: string;
  assets: CopyTradingAsset[];
  [key: string]: any;
}

export interface InvestResponse {
  status: 'Executed' | 'Scheduled' | 'Failed';
  copyTradingTransactionId: number;
}

namespace CopyTradingService {
  /**
   * Create a new copy trading portfolio
   *
   * @param body portfolio details including name, description, and asset allocations
   * @returns the created portfolio
   */
  export async function createPortfolio(body: CreateCopyTradingBody): Promise<CopyTradingResponse> {
    const res = await API.post('/trading/copy-trading', body);
    return res?.data;
  }

  /**
   * Invest a dollar amount into a copy trading portfolio.
   * The backend splits the investment across all stocks proportionally.
   *
   * @param copyTradingId the id of the copy trading portfolio
   * @param amountInCents the amount to invest in cents
   * @returns invest response with status
   */
  export async function investInPortfolio(
    copyTradingId: number,
    amountInCents: number
  ): Promise<InvestResponse> {
    const res = await API.post(`/trading/copy-trading/${copyTradingId}/invest`, {
      amountInCents,
    });
    return res?.data;
  }

  /**
   * Get details of a copy trading portfolio
   *
   * @param copyTradingId the id of the copy trading portfolio
   * @returns portfolio details
   */
  export async function getPortfolio(copyTradingId: number): Promise<CopyTradingResponse> {
    const res = await API.get(`/trading/copy-trading/${copyTradingId}`);
    return res?.data;
  }
}

export default CopyTradingService;

